import Vue from 'vue'
import router from './router'
import store from './store'
import {
  UI_CACHE_TENANT_PARAMS_DATA,
  ACCESS_TOKEN,
  USER_NAME,
  USER_INFO,
  USER_AUTH,
  SYS_BUTTON_AUTH,
  UI_CACHE_DB_DICT_DATA,
  TENANT_ID,
  CACHE_INCLUDED_ROUTES,
  ENCRYPTED_STRING,
  OAUTH2_LOGIN_PAGE_PATH
} from '@/store/mutation-types'
import { generateIndexRouter, isOAuth2AppEnv } from '@/utils/util'
import { getAction } from '@/api/manage'
import { OpenApiEncrypt } from '@/utils/config/SysBaseConfig'
import { decryption } from '@/utils/encryption/aesEncrypt'
import { getEncryptedString } from '@/utils/encryption/aesEncrypt'
import { welcome } from '@/utils/util'

const whiteList = ['/user/login', '/user/register', '/user/register-result', '/user/alteration'] // no redirect whitelist
whiteList.push(OAUTH2_LOGIN_PAGE_PATH)

router.beforeEach((to, from, next) => {
  if (Vue.ls.get(ACCESS_TOKEN)) {
    // getEncryptedString().then((data) => {
    //   store.dispatch('CheckLogin').then((response) => {
    //     if (response.success) {
    //       next()
    //     } else {
    //       store.dispatch('Logout').then(() => {
    //         window.location.reload();
    //       })
    //     }
    //   })
    // })
    next()
  } else {
    next()
  
  }
})

router.afterEach(() => {
})
